import React from 'react'
import './AssignmentModalHeader.scss';
import { useTranslation } from 'react-i18next';
import districtIcon from "@/images/icons/district-icon.svg";
interface AssignmentModalHeaderProps {
  skillName: string;
  standards: any;
  domain: string;
  source: string;
}

const getDomainTag = (domain: string) => {
  const domainTags = {
    PA: 'Phonological Awareness Thread',
    D: 'Decoding Thread',
    HFW: 'High Frequency Words Thread',
    BK: 'Background Knowledge Thread',
    V: 'Vocabulary Thread',
    SR: 'Structures and Reasoning Thread',
  }
  return domainTags[domain as keyof typeof domainTags] || domain;
}



export const AssignmentModalHeader = ({ skillName, standards, domain, source }: AssignmentModalHeaderProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="assignment-modal-header">
      <div className={`assignment-modal-header-domain-tag domain-${domain}`}>
        {getDomainTag(domain)}
      </div>
      <div className="assignment-modal-header-metadata-container">
        <h3>{skillName}</h3>
        <div className="standards-container">
          {standards && <span className="standards-container-text">{standards}</span>}
          {source && <span className="standards-container-source">
            <img src={districtIcon} />
            <span className="standards-container-source-text">{t(source)}</span>
          </span>}
        </div>
      </div>
    </div>
  )
}
